/**
 * 速度監視の実施条件・速度警告モーダルの表示前提条件を提供するcomposable。
 *
 * 監視処理の起動可否、警告モーダルの表示前提など、useSpeedMonitor / SpeedAlert で
 * 重複していた業務条件をここに集約する。
 * 警告抑制や速度超過判定など、状態合成に近いロジックは呼び出し側に残す。
 */
export const useSpeedMonitoringConditions = () => {
  const { isPc } = useDevice();
  const { loginUser } = storeToRefs(useLoginUserStore());
  const { isLoginPage } = useRouteConditions();
  const runtimeConfig = useRuntimeConfig();

  /** ログイン状態か */
  const isLoggedIn = computed(() => !!loginUser.value);

  /** ランタイム設定で速度監視が明示的に無効化されているか */
  const isSpeedMonitoringDisabledByConfig = computed(() =>
    parsePublicBoolean(runtimeConfig.public.speedDisableMonitoring),
  );

  /** 速度監視処理を起動してよいか */
  const canRunSpeedMonitoring = computed(() =>
    !isPc.value
    && !isSpeedMonitoringDisabledByConfig.value
    && isLoggedIn.value,
  );

  /**
   * 速度警告モーダルを表示してよい業務状態か。
   *
   * 警告抑制中の判定や速度超過判定（isSpeedExceeded / isGpsError）はモーダル表示固有の
   * 状態合成に近いため、ここでは前提条件のみを判定する。
   */
  const canShowSpeedAlert = computed(() =>
    !isPc.value
    && !isSpeedMonitoringDisabledByConfig.value
    && isLoggedIn.value
    && !isLoginPage.value,
  );

  return {
    isLoggedIn,
    isLoginPage,
    isSpeedMonitoringDisabledByConfig,
    canRunSpeedMonitoring,
    canShowSpeedAlert,
  };
};
